/*
 * Copyright 2024 GLA UK Research and Development Directive
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CookiesDialogComponent } from 'src/app/modules/shared/dialogs/cookies-dialog/cookies-dialog.component';
import { DisclaimerDialogComponent } from 'src/app/modules/shared/dialogs/disclaimer-dialog/disclaimer-dialog.component';

/**
 * The Footer Bar Component.
 */
@Component({
    selector: 'footer-bar',
    templateUrl: './footer-bar.component.html',
    styleUrls: ['./footer-bar.component.scss'],
    standalone: false
})
export class FooterBarComponent implements OnInit {

    // Component Variables
    private disclaimerModalRef: NgbModalRef;
    private cookiesModalRef: NgbModalRef;

    /**
     * The Footer Bar Component Constructor.
     */
    constructor(protected modalService: NgbModal) {

    }

    /**
     * The Angular On Init function.
     */
    ngOnInit(): void {

    }

    /**
     * This function opens the disclaimer modal dialog.
     */
    disclaimerDlg() {
        this.disclaimerModalRef = this.modalService.open(DisclaimerDialogComponent, { size: 'xl' });
    }

    /**
     * This function opens the cookies modal dialog.
     */
    cookiesDlg() {
        this.cookiesModalRef = this.modalService.open(CookiesDialogComponent, { size: 'xl' });
    }

}
